<template>
  <div class="collectSupplierContent" v-if="isLogined">
    <div class="title">
      店铺收藏 
      
      <div class="cancelManageCollect" v-if="isManage"><input type="button" value="取消管理" @click="manageCollect(false)"></div>
      <div class="manageCollect" v-else><input type="button" value="收藏管理" @click="manageCollect(true)"></div>
      <div class="delCollect" v-if="isManage" @click="delCollect"> <img src="https://file-sz.fjjykj.com.cn/Supply/s4fa98fed29b1ec7c9825589935fabd4a.png"> <div class="labelName">删除</div></div>
      <div class="allSelect" v-if="isManage"> <el-checkbox v-model="isAll" @change="handleCheckboxChange"/><span class="labelName"  @click="allSelect">全选</span></div>
      
    </div>
    <div class="collectSupplierList" :key="collectSupplierIndex"> 
      <ul v-if="supplierList.length>0">
          <li v-for="(item,i) in supplierList" :key="'goods_'+i" class="collectSupplier">                          
            <img v-if="item.supplierLogo" :src="item.supplierLogo"/>
            <div class="supplierName">{{item.supplierName}}</div>
            <div class="supplierLabel" v-if="item.labels"><span v-for="(item,index) in item.labels" :key="index">{{item}}</span></div>
            <div class="supplierBtn" @click="toSupplier(item)"><div><img class="img1" src="http://file-sz.fjjykj.com.cn/Supply/se919e00d1de3930d887d67eebd282e15.png"/> <img class="img2" src="https://file-sz.fjjykj.com.cn/Supply/s3ddb52f022fb50f6fe82592174971b0d.png"></div></div>
            <div class="selectSupplier" v-if="isManage">
                <el-checkbox v-model="item.checked" />
            </div>
            <div class="delSupplier"><img @click="delCollectItem(item.supplierId)" src="https://file-sz.fjjykj.com.cn/Supply/s7700d715392bcc97de0073f0ed076c23.png"></div>
          </li>      
      </ul>  
     </div>   
  </div>
</template>
<style>
@import '../../styles/collectSupplier.css';
</style>
<script>
  import api from '@/api'
  import { getCollectSuppliers, doRemoveCollect } from '@/api/supplier'
  import YButton from '@/components/yButton'
  import YShelf from '@/components/shelf' 
  import { mapState} from 'vuex'
  export default {
    
    data () {
      return {
        isAll:false,
        isManage:false,
        supplierList: [],   
        goodsTotal:0,
        collectSupplierIndex:0,
        queryForm:{
          SkipCount:1,
          MaxResultCount:8
        }
      }
    },
    computed: {
      ...mapState(['isLogined']), 
    },
    methods: { 
      toLogin() {
        this.$router.push({ name: 'userLogin' })
      },
      message (m) {
        this.$message.error({
          message: m
        })
      },
      manageCollect(val)
      {
        this.isManage=val;
      },
      delCollect()
      {
        var tempIds = [];
        for(var i=0;i<this.supplierList.length;i++)
        {
            if(this.supplierList[i].checked==true)
            {
               tempIds.push(this.supplierList[i].supplierId);
            }
        }
        if(tempIds.length==0)
        {
          this.$message({ message: '请选择要删除的收藏', type: 'error', customClass: 'c-msg' })
          return;
        }
        this.$confirm('确定删除吗?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'}).then((res) => {
          for(var i=0;i<tempIds.length;i++)
          {
            doRemoveCollect({supplierId:tempIds[i]})
          }
          this.$message({ message: '删除成功', type: 'success', customClass: 'c-msg' })
         
          setTimeout(() => {
            this._collectList()
            }, 1500)
        })        
      },
      delCollectItem(id)
      {
        this.$confirm('确定删除吗?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'}).then((res) => {
          doRemoveCollect({supplierId:id}).then(res => {
            this.$message({ message: '删除成功', type: 'success', customClass: 'c-msg' })
           this._collectList()
          })
        })        
      },
      allSelect()
      {       
        this.collectSupplierIndex = this.collectSupplierIndex+1;
         if(this.isAll)
         {
            this.isAll=false;
            for(var i=0;i<this.supplierList.length;i++)
            {
              this.supplierList[i].checked=false;
            }
         }
         else
         {
            this.isAll=true;
            for(var i=0;i<this.supplierList.length;i++)
            {
              this.supplierList[i].checked=true;
            }
         }
      },
      handleCheckboxChange()
      {
        this.isAll= !this.isAll;
        this.allSelect();
      },
      toSupplier(row)
      {
        window.location = '//' + window.location.host + '/#/search?searchType=0&&sLogo='+ row.supplierLogo+'&&sName='+ row.supplierName+'&&sId='+ row.supplierId
      },
      showModal(item){     
        this.$refs['selectSpec'].showSelect(item)         
      },
      handleSizeChange (val) {
        this.queryForm.MaxResultCount = val
        this._collectList()
      },
      handleCurrentChange (val) {
        this.queryForm.SkipCount = val
        this._collectList()
      },
      async _collectList () { 
        await getCollectSuppliers(this.queryForm).then(res => {     
          if (res.data.success === true) {
            this.supplierList = [];
            res.data.result.forEach(x => {
              var temp = {checked:false };
              let newObj = { ...x, ...temp };
              this.supplierList.push(newObj)
            });          
          } else {
           this.supplierList = []
          }
        }).catch(error => {
            this.supplierList = []
        })
      },           
    },
    created () {
     if(this.isLogined) 
     {      
        this._collectList()
     }
    },
    mounted() {
     
    },
    components: {
      YButton,
      YShelf
    }
  }
</script>


// WEBPACK FOOTER //
// CollectSupplierList.vue?72fae698